import { createGlobalStyle } from 'styled-components';

export const GlobalAlertsStyled = createGlobalStyle`
    .alert {
        position: relative;
        padding: 16px;
        margin-bottom: 1rem;
        border: 1px solid transparent;
        border-radius: 16px;

        > svg {
            float: left;

            + span {
                display: block;
                padding-left: 2em;
            }
        }
    }
    
    .alert-lg {
        padding: 1.5rem;
    }

    .alert-warning {
        color: #FF8F00;
        background-color: rgba(255, 143, 0, 0.1);
        border-color: transparent;
    }

    .alert-success {
        color: var(--color-positive);
        background-color: var(--background-positive-10);
        border: none;
    }
    
    .alert-info {
        background-color: var(--color-surface-secondary);
        color: var(--color-white-95);
        border: none;
    }
    
    .alert-info-outside {
        color: #FFFFFF;
        background: none;
    }
`;